import "@/lib/assertBrowserEnvironment";
import ReactDOM from "react-dom/client";
import "@/types/tiptapDirectiveSuggestionStorage";
import "./index.css";
import { StrictMode, type ErrorInfo } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "@/providers/ConfigProvider";
import { ThemeVarsProvider } from "@/providers/ThemeVarsProvider";
import { ErrorBoundary } from "react-error-boundary";
import { AppRootErrorFallbackTopLevel } from "@/components/organisms/appRootErrorFallbackTopLevel";
import App from "./App";

const logTopLevelErrorBoundary = (error: unknown, info: ErrorInfo) => {
  console.error("Top-level ErrorBoundary:", error, info);
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={AppRootErrorFallbackTopLevel}
      onError={logTopLevelErrorBoundary}
    >
      <ConfigProvider>
        {({ store, persistor, router }) => (
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <ThemeVarsProvider>
                <App router={router} />
              </ThemeVarsProvider>
            </PersistGate>
          </Provider>
        )}
      </ConfigProvider>
    </ErrorBoundary>
  </StrictMode>,
);
